import "./App.css";
import Header from "./components/header/Header";
import Main from "./components/main/Main";

function App() {
	return (
		<div className="App">
			<Header />
			<hr />
			<Main />
		</div>
	);
}

export default App;
